<template>
    <div>CTC INDIVIDUAL</div>
</template>